import { render, staticRenderFns } from "./rspToLeaveGrantedInstructions.vue?vue&type=template&id=71db0f42"
import script from "./rspToLeaveGrantedInstructions.vue?vue&type=script&lang=ts"
export * from "./rspToLeaveGrantedInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports